import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Row, Col } from 'antd';
import 'swiper/css';
import 'swiper/css/navigation';
import { Navigation } from 'swiper/modules';

const CustomerServices = ({ data }) => {
  return (
    <div>
      <section className='customtestimonals'>
        <h3 style={{ color: '#000', textAlign: 'middle' }}>{data?.title}</h3>
        <div className="container">
          <Row style={{
            background: 'linear-gradient(90deg, rgba(249, 230, 3, 1) 0%, rgba(246, 178, 1, 1) 34%, rgba(249, 230, 3, 1) 60%, rgba(248, 209, 2, 1) 65%, rgba(247, 185, 1, 1) 77%, rgba(247, 183, 1, 1) 87%, rgba(249, 236, 3, 1) 100%)',
            padding: '60px 0'
          }}>
            <Col span={24}>
              <Swiper
                navigation={true}
                modules={[Navigation]}
                className="mySwiper"
                dots={true}

              >
                {data?.testimonials?.map(item => (
                  <SwiperSlide>
                    <div className="sildertest">
                      <p>
                        "{item?.content}"
                      </p>
                      <h4 >- {item?.name}</h4>
                      <h5>{item?.designation}</h5>
                    </div>
                  </SwiperSlide>
                )
                )}
                {/* Additional SwiperSlide components */}
              </Swiper>
            </Col>
          </Row>
        </div>
      </section>

      <style jsx>{`
        .swiper-button-next,
        .swiper-button-prev {
          background:#000; /* Set background color to black */
          border-radius: 50%;
          width: 40px;
          height: 40px;
          color: white; /* Icon color white */

          border: 2px solid #fff; /* Optional border for better contrast */
        }

        .swiper-button-next::after,
        .swiper-button-prev::after {
          color: white; /* Ensures the arrow icons are white */
              font-size: 18px;
        }

        .swiper-button-next:hover,
        .swiper-button-prev:hover {
         

        .sildertest {
          text-align: center;
        }

        .customtestimonals h3 {
          margin-bottom: 30px; /* Adds spacing between title and Swiper */
        }
      `}</style>
    </div>
  );
}

export default CustomerServices;
